_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
{ currentModelManager } = require 'app/scripts/controller/currentModelManager'
config = '@trello/config'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
parseURL = require 'url-parse'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PostMessageIO = require '@atlassian/trello-post-message-io'
Promise = require 'bluebird'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
{ sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
{ track, trackUe } = require '@trello/analytics'
xtend = require 'xtend'

INITIALIZE_TIMEOUT = 20000 # gives us 20 seconds to load the index iframe for a Power-Up

IFrameIOError = makeErrorEnum 'IFrameIO', [
  'Invalid'
  'NotHandled'
  'Timeout'
]

host = null
getHost = ->
  if !host?
    id = 'iframe-io-host'
    host = document.createElement('div')
    host.id = id
    body = document.getElementsByTagName('body')[0]
    if !body
      throw Error('no body to host iframes')
    body.appendChild(host)
  host

module.exports = class IFrameIO
  @Error: IFrameIOError
  constructor: (@url, @handlers, @id, @declaredCapabilities) ->

  _getIO: ->
    startTime = performance?.now?() || Date.now()
    iframeLoaded = false
    initializeCalled = false
    iframeLoadTime = 0
    initializeStartTime = 0
    @_io ?= new Promise (resolve) =>
      if !pluginValidators.isValidUrlForIframe(@url)
        throw IFrameIOError.Invalid("Provided iframe source not valid: #{@url}")

      iframe = document.createElement('iframe')
      iframe.sandbox = sandboxParams
      iframe.onload = ->
        iframeLoaded = true
        loadTime = performance?.now?() || Date.now()
        iframeLoadTime = Math.ceil(loadTime - startTime)
      iframe.src = @url
      # see: https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-permissions-in-cross-origin-iframes
      iframe.allow = 'microphone; camera'
      @_iframeEl = iframe

      getHost().appendChild(iframe)

      secret = PostMessageIO.randomId(64)
      @implementedCapabilities = []

      io = new PostMessageIO
        Promise: Promise
        local: window
        remote: iframe.contentWindow
        targetOrigin: parseURL(@url).set('pathname', '').href
        secret: secret
        handlers: xtend @handlers,
          'initialize': (t, implementedCapabilities) =>
            initializeCalled = true
            initializeStartTime = performance?.now?() || Date.now()
            @implementedCapabilities = implementedCapabilities
            nonImplemented = _.difference(@declaredCapabilities, implementedCapabilities)
            if nonImplemented.length > 0
              console?.warn "Power-Up #{@id} declares capabilities that are not implemented", nonImplemented
            nonDeclared = _.difference(implementedCapabilities, @declaredCapabilities)
            if nonDeclared.length > 0
              console?.warn "Power-Up #{@id} implements capabilities that haven't been enabled", nonDeclared
            return {
              locale: Auth.myLocale()
              member: Auth.myId()
              secret: secret
              version: if /^build-\d+$/.test(config.clientVersion) then config.clientVersion else 'unknown'
            }
          'ready': =>
            endTime = performance?.now?() || Date.now()
            resolve(io)
            trackUe('Power-Up', 'completes', 'initializing', '', '', '', @id)
            sendPluginTrackEvent({
              idPlugin: @id
              idBoard: currentModelManager.getCurrentBoard()?.get('id')
              event:
                action: 'initialized'
                actionSubject: 'powerUp'
                source: 'iframeIO'
                attributes:
                  elapsedMs: Math.ceil(endTime - startTime)
                  iframeLoadMs: iframeLoadTime
                  initializeMs: if initializeStartTime != 0 then Math.ceil(endTime - initializeStartTime) else 0
                  declaredCapabilities: @declaredCapabilities.sort()
                  implementedCapabilities: @implementedCapabilities.sort()
                  wasLoaded: iframeLoaded
                  wasInitialized: initializeCalled
            })
    .timeout(INITIALIZE_TIMEOUT)
    .catch Promise.TimeoutError, =>
      endTime = performance?.now?() || Date.now()
      trackUe('Power-Up', 'times-out', 'initializing', '', '', '', @id)
      sendPluginTrackEvent({
        idPlugin: @id
        idBoard: currentModelManager.getCurrentBoard()?.get('id')
        event:
          action: 'timedOut'
          actionSubject: 'powerUp'
          source: 'iframeIO'
          attributes:
            elapsedMs: Math.ceil(endTime - startTime)
            iframeLoadMs: iframeLoadTime
            initializeMs: if initializeStartTime != 0 then Math.ceil(endTime - initializeStartTime) else 0
            declaredCapabilities: @declaredCapabilities.sort()
            wasLoaded: iframeLoaded
            wasInitialized: initializeCalled
      })
      if (console?.error)
        console.error("Error, timeout while initializing index iframe for #{@url}. Timeout=#{ INITIALIZE_TIMEOUT }ms")
      throw IFrameIOError.Timeout("unable to initialize iframe-io in #{ INITIALIZE_TIMEOUT }ms")

  request: (command, options, timeout) ->
    @_getIO()
    .then (io) ->
      startTime = Date.now()
      io.request(command, options)
      .timeout(timeout)
      .catch Promise.TimeoutError, ->
        if (console?.error)
          console.error("IFrameIO request timed out. Command=#{command}, Plugin=#{options?.context?.plugin}, Elapsed=#{Date.now() - startTime}")
        throw IFrameIOError.Timeout("#{ command } did not complete in #{ timeout }ms")
    .catch (err) ->
      throw IFrameIOError.NotHandled("Request to run '#{ command }' failed due to error: '#{ err.message }'")

  drop: ->
    @_iframeEl?.parentNode.removeChild(@_iframeEl)
